import { useTranslations } from 'next-intl'

import { useFormatCurrency } from '@/shared/lib'

import { TRoomDetail } from '../../model/schema'

export type Props = Pick<
  TRoomDetail,
  | 'roomName'
  | 'roomCnt'
  | 'bathroomCnt'
  | 'sittingroomCnt'
  | 'cookroomCnt'
  | 'usingFee'
  | 'mgmtFee'
> & {
  propertyType: string
  province: string
  town: string
}

export const MobileOverview = ({
  province,
  town,
  propertyType,
  roomName,
  roomCnt,
  bathroomCnt,
  sittingroomCnt,
  cookroomCnt,
  usingFee,
  mgmtFee,
}: Props) => {
  const t = useTranslations()

  const { formatCurrency } = useFormatCurrency()

  return (
    <>
      <div className="mb-0">
        <h3 className="typo-label1 mb-0.5 font-semibold text-gray-900">
          {t('search_panel.recent_room.roomName', {
            address: `${province} ${town}`,
            propertyType,
          })}
        </h3>
        <p className="typo-label2 mb-1 font-normal text-gray-900">{roomName}</p>
        <div className="typo-caption1 flex gap-2 font-normal text-gray-500">
          {roomCnt > 0 && (
            <p>
              <span>{t('common.br')}</span>
              <span className="text-gray-900">{roomCnt}</span>
            </p>
          )}
          {bathroomCnt > 0 && (
            <p>
              <span>{t('common.ba')}</span>
              <span className="text-gray-900">{bathroomCnt}</span>
            </p>
          )}
          {cookroomCnt > 0 && (
            <p>
              <span>{t('common.kit')}</span>
              <span className="text-gray-900">{cookroomCnt}</span>
            </p>
          )}
          {sittingroomCnt > 0 && (
            <p>
              <span>{t('common.lr')}</span>
              <span className="text-gray-900">{sittingroomCnt}</span>
            </p>
          )}
        </div>
      </div>

      <div className="flex items-center">
        <p className="flex items-center gap-px font-bold text-gray-900">
          <strong className="typo-body1 font-bold">
            {formatCurrency(usingFee + mgmtFee, {
              unit: chunks => <span className="typo-label2">{chunks}</span>,
            })}
          </strong>
        </p>
        <span className="typo-body1 w-3 text-center font-light text-gray-200">
          /
        </span>
        <span className="typo-label1 font-bold text-purple-500">
          {t('common.week_unit')}
        </span>
      </div>
    </>
  )
}
